// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__U7ZBy","fadeIn":"Overlay_fadeIn__i1eRx"};